// extracted by mini-css-extract-plugin
var _1 = "SettingsButtonContainer__body--LCtTR";
var _2 = "SettingsButtonContainer__buttonWrapper--UDPXQ";
export { _1 as "body", _2 as "buttonWrapper" }
